import '../LandingPage/LandingPage.css';
import NoticeModal from './NoticeModal';

function LandingPage() {
    return (
        <>
            <NoticeModal />
            <div className="landing-container">
                <div className="landing-content">
                    <div className="text-group">
                        <h1 className="main-title">
                            당신의 소중한 권리<br />
                            <span className="highlight">온평</span>이 지켜드립니다
                        </h1>
                        <p className="sub-title">
                            법률사무소 온평<br />따뜻한 공감, 냉철한 해결
                        </p>
                        <div className="cta-area">
                            <a href="/contact" className="btn-contact">상담 요청</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LandingPage;